export default["Consultation","Created Solution","KPI","Licensing","Milestone","Project Completion","Time"]